import { h } from 'preact';
import * as actions from 'store/actions';

let staticRender;
staticRender = (props) => (
	<div>
		<script dangerouslySetInnerHTML={{ __html: `
(function(w,a,t,c,h){w[c]=w[c]||[];w[c].push({'jw.start':new Date().getTime(),event:'jw.js'});var f=a.getElementsByTagName(t)[0],j=a.createElement(t),jd=c!='jwData'?'&l='+c:'';j.async=true;j.src='//j.ustwat.ch/t.js?c='+h+jd;f.parentNode.insertBefore(j,f)})(window,document,'script','jwData','a3123961b13e6f540819af6b081fb156');</script>
`
			}}
		/>
	</div>
);

let storeListeners = {};
// storeListeners[actions.TICKET_LINK_CLICKED] = (screening, theater, ev, provider) => {
//
// };

export const disabledLevels = {
	// base: true,
	// studio: true,
	// studioRegion: true,
	// title: true,
};

export {
	staticRender,
	storeListeners
};
